
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconPackage } from '@ds/icons/IconPackage'
import { IconPromo } from '@ds/icons/IconPromo'
import { IconQuality } from '@ds/icons/IconQuality'
import { IconReassuranceGlobeOutlined } from '@ds/icons/IconReassuranceGlobeOutlined'
import { IconTruckExpress } from '@ds/icons/IconTruckExpress'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'
import FormattedMessage from '@i18n/components/FormattedMessage'
import WarrantyModal from '@reassurance/components/WarrantyModal'

import ShippingModal from '../Modals/ShippingModal'

import { E_WASTE_LINK } from './ReassuranceBlock.constants'
import translations from './ReassuranceBlock.translations'

const DATE_FORMAT = {
  month: 'short',
  day: 'numeric',
}

export default {
  components: {
    RevLink,
    FormattedMessage,
    IconPackage,
    IconPromo,
    IconTruckExpress,
    IconQuality,
    IconReassuranceGlobeOutlined,
    ShippingModal,
    WarrantyModal,
  },
  props: {
    discount: {
      type: Object,
      default: () => ({}),
    },
    eWaste: {
      type: String,
      default: '',
    },
    isAccessory: {
      type: Boolean,
      required: true,
    },
    shipping: {
      type: Object,
      required: true,
    },
    warrantyDelay: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters({
      country: 'config/country',
      ewasteGuideRoute: 'config/ewasteGuideRoute',
    }),
    translations: () => translations,

    shouldDisplayFreeShipping() {
      return !isEmpty(this.shipping.free)
    },

    discountRate() {
      return this.discount.rate
    },

    shouldDisplayDiscount() {
      return this.discount.isDisplayed && !isEmpty(this.discountRate)
    },

    isExpressShippingAvailable() {
      if (!isEmpty(this.shipping.express)) {
        return Number(this.shipping.express.price.amount) > 0
      }

      return false
    },

    expressShippingPrice() {
      if (this.isExpressShippingAvailable) {
        return this.shipping.express.price
      }

      return {}
    },

    expressShippingPriceLabel() {
      return this.$t.price(this.expressShippingPrice)
    },

    shouldDisplayExpressShipping() {
      return this.isExpressShippingAvailable
    },

    shouldDisplayWarrantyDelay() {
      return !isEmpty(this.warrantyDelay)
    },

    shouldDisplayDeliveryModal() {
      return !this.$config.KILL_DELIVERY_MODAL
    },

    freeShippingDays() {
      if (this.shouldDisplayFreeShipping) {
        const days = Math.ceil(this.shipping.free.delayInHours / 24)

        return days
      }

      return false
    },

    shouldDisplayElectronicWaste() {
      return !this.isAccessory && !isEmpty(this.eWaste)
    },

    shouldDisplayElectronicWasteLink() {
      return (
        !isEmpty(this.ewasteGuideRoute) &&
        E_WASTE_LINK[this.country] &&
        !this.isAccessory
      )
    },

    shouldDisplayElectronicWasteText() {
      return !this.shouldDisplayElectronicWasteLink
    },

    freeEarliestArrivalDate() {
      return this.$t.date(
        new Date(this.shipping.free.earliestArrivalDate),
        DATE_FORMAT,
      )
    },

    freeLatestArrivalDate() {
      return this.$t.date(
        new Date(this.shipping.free.latestArrivalDate),
        DATE_FORMAT,
      )
    },

    expressEarliestArrivalDate() {
      return this.$t.date(
        new Date(this.shipping.express.earliestArrivalDate),
        DATE_FORMAT,
      )
    },

    expressLatestArrivalDate() {
      return this.$t.date(
        new Date(this.shipping.express.latestArrivalDate),
        DATE_FORMAT,
      )
    },
  },

  methods: {
    openShippingModal() {
      openModal(MODAL_NAMES.PRODUCT.EXPRESS_SHIPPING)
    },
    openWarrantyModal() {
      openModal(MODAL_NAMES.REASSURANCE.WARRANTY)
    },
    openSatisfactionModal() {
      openModal(MODAL_NAMES.REASSURANCE.SATISFACTION)
    },
  },
}
